"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRowSelected = exports.getCssClasses = exports.applyFormatterResult = exports.createElementText = exports.isEmpty = exports.isSlickEvent = exports.isPluginObject = exports.containsValue = exports.chainingFilters = exports.containsFilterFn = exports.humanFileSize = exports.fixColumnHeaderClickedAfterResize = exports.saveData = exports.sortDataView = exports.getSortColumns = exports.isExportableColumn = exports.isSystemColumn = exports.cssImage = exports.assertNonNullish = void 0;
const debug_1 = __importDefault(require("debug"));
const _ = __importStar(require("lodash"));
const file_saver_1 = require("file-saver");
const log = (0, debug_1.default)('itp:slick:helpers');
function assertNonNullish(value, message) {
    if (value === null || value === undefined) {
        throw Error(message);
    }
}
exports.assertNonNullish = assertNonNullish;
function cssImage(value) {
    value = value
        .toLowerCase()
        .replace('_', '-')
        .replace('.', '-');
    return `slick--img-${value}`;
}
exports.cssImage = cssImage;
function isSystemColumn(col) {
    return col.name === '' || col.systemColumn;
}
exports.isSystemColumn = isSystemColumn;
function isExportableColumn(col) {
    return !isSystemColumn(col) && !col.noExport;
}
exports.isExportableColumn = isExportableColumn;
function getSortColumns(grid) {
    let columns = grid.getColumns();
    return _.map(grid.getSortColumns(), col => ({
        sortCol: columns[grid.getColumnIndex(col.columnId)],
        sortAsc: col.sortAsc
    }));
}
exports.getSortColumns = getSortColumns;
const isValue = o => o != null && o.toString().trim().length > 0;
function sortDataView(grid, dataView, sorters) {
    dataView.sort(function (row1, row2) {
        let s, col;
        for (let i = 0, len = sorters.length; i < len; i++) {
            s = sorters[i];
            col = s.sortCol;
            if (!s || !col || !col.sortable)
                continue;
            let field = (col.params && col.params.sortPath) || col.field, sign = s.sortAsc ? 1 : -1, value1 = col.textFormatter
                ? col.getFormattedText(row1, null, _.get(row1, field), col, row1)
                : _.get(row1, field), value2 = col.textFormatter
                ? col.getFormattedText(row2, null, _.get(row2, field), col, row2)
                : _.get(row2, field);
            if (!isValue(value1) && isValue(value1))
                return 0 * sign;
            if (!isValue(value1) && isValue(value2))
                return -1 * sign;
            if (!isValue(value2) && isValue(value1))
                return 1 * sign;
            let result = (value1 === value2 ? 0 : value1 > value2 ? 1 : -1) * sign;
            if (result !== 0) {
                return result;
            }
        }
        return 0;
    }, true);
    grid.invalidateAllRows();
    grid.render();
}
exports.sortDataView = sortDataView;
function getCellValueForExport(grid, column, data, options) {
    const fmt = column.formatter;
    const value = data[_.toString(column.field)];
    let numberFormatter;
    if (options.localeCode) {
        numberFormatter = Intl.NumberFormat(options.localeCode);
    }
    function toResult(v) {
        if (_.isNumber(v) && numberFormatter) {
            return numberFormatter.format(v).replace(/\s/g, '');
        }
        return v;
    }
    if (_.isFunction(fmt)) {
        if (fmt.exportRawData) {
            return toResult(value);
        }
        if (_.isFunction(fmt.exportDataFormatter)) {
            return toResult(fmt.exportDataFormatter(-1, -1, value, column, data, grid));
        }
        return toResult(fmt(-1, -1, value, column, data, grid));
    }
    return toResult(value);
}
function normCellValue(value, quoteChar) {
    if (isEmpty(value)) {
        return '';
    }
    if (_.isArray(value)) {
        if (value.length === 0) {
            return '';
        }
        value = value.join(', ');
    }
    return `${quoteChar}${value}${quoteChar}`;
}
function formatDataItems(grid, columns, items, options) {
    const fields = [];
    const columnsByField = {};
    const header = [];
    columns.forEach(col => {
        const fieldName = _.toString(col.id);
        fields.push(fieldName);
        columnsByField[fieldName] = col;
        header.push(_.toString(col.name));
    });
    const result = [header];
    let row;
    for (let i = 0, len = items.length; i < len; i++) {
        row = items[i];
        if (row.__nonDataRow) {
            continue;
        }
        result.push(_.map(fields, f => getCellValueForExport(grid, columnsByField[f], row, options)));
    }
    return result;
}
const BOM = '\uFEFF';
async function saveData(grid, items, fileName, format = 'csv', options) {
    log('saveData - options: %o', options);
    const columns = _.filter(grid.getColumns(), isExportableColumn);
    log('saveData - columns: %o', options);
    const rows = formatDataItems(grid, columns, items, options);
    if (rows.length < 2) {
        return;
    }
    const delimiter = options.delimiter, quoteChar = options.quoteChar, content = BOM +
        rows
            .map(row => row.map(p => normCellValue(p, quoteChar)).join(delimiter))
            .join('\n');
    (0, file_saver_1.saveAs)(new Blob([content], { type: 'text/plain;charset=utf-8' }), fileName);
}
exports.saveData = saveData;
function fixColumnHeaderClickedAfterResize(grid) {
    let columnResized;
    grid.onColumnsResized.subscribe(() => (columnResized = new Date().getTime()));
    grid.onHeaderClick.subscribe(e => {
        if (columnResized && new Date().getTime() - columnResized < 1000) {
            e.stopImmediatePropagation();
            e.preventDefault();
        }
    });
}
exports.fixColumnHeaderClickedAfterResize = fixColumnHeaderClickedAfterResize;
const SI_UNITS = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const OT_UNITS = ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
function humanFileSize(bytes, si) {
    const thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    const units = si ? SI_UNITS : OT_UNITS;
    let u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1) + ' ' + units[u];
}
exports.humanFileSize = humanFileSize;
function containsFilterFn(grid) {
    return function (item) {
        let columns = grid.getColumns(), result = true;
        for (let i = 0; i < columns.length; i++) {
            const col = columns[i], filterValues = col && col.filterValues;
            if (col && filterValues && filterValues.length > 0) {
                if (_.isArray(item[col.field])) {
                    result =
                        result &&
                            _.some(item[col.field], p => _.indexOf(filterValues, p) > -1);
                }
                else {
                    result = result && _.indexOf(filterValues, item[col.field]) > -1;
                }
            }
        }
        return result;
    };
}
exports.containsFilterFn = containsFilterFn;
function chainingFilters(...filters) {
    return function (item) {
        return _.every(filters, fn => fn(item));
    };
}
exports.chainingFilters = chainingFilters;
function containsValue(cellValue, filterValue) {
    if (_.isArray(cellValue)) {
        cellValue = cellValue.join(', ');
    }
    if (isEmpty(cellValue)) {
        return false;
    }
    if (!_.isString(cellValue)) {
        cellValue = cellValue.toString();
    }
    return cellValue.toLowerCase().indexOf(filterValue.toLowerCase()) > -1;
}
exports.containsValue = containsValue;
function isPluginObject(obj) {
    return _.isFunction(obj['init']) && _.isFunction(obj['destroy']);
}
exports.isPluginObject = isPluginObject;
function isSlickEvent(obj) {
    return (_.isFunction(obj['subscribe']) &&
        _.isFunction(obj['unsubscribe']) &&
        _.isFunction(obj['notify']));
}
exports.isSlickEvent = isSlickEvent;
function isEmpty(value) {
    return (_.isUndefined(value) ||
        value === null ||
        (_.isString(value) && value.trim() === ''));
}
exports.isEmpty = isEmpty;
function createElementText(tagName, attributes, content = null) {
    let result = `<${tagName}`;
    _.each(attributes, (v, k) => {
        if (v !== null) {
            result += ` ${k}="${decodeURIComponent(v)}"`;
        }
    });
    if (content === null) {
        content = '';
    }
    return `${result}>${content}</${tagName}>`;
}
exports.createElementText = createElementText;
function applyFormatterResult(el, result) {
    if (_.isString(result)) {
        el.textContent = result;
        return;
    }
    el.textContent = _.toString(result);
}
exports.applyFormatterResult = applyFormatterResult;
function getCssClasses(value) {
    if (!value) {
        return;
    }
    if (_.isArray(value)) {
        return _.map(value, getCssClasses).join(' ');
    }
    if (_.isObject(value)) {
        return _.reduce(value, (m, v, k) => {
            if (v) {
                return m + ' ' + k;
            }
            return m;
        }, '');
    }
    return value.toString();
}
exports.getCssClasses = getCssClasses;
function isRowSelected(data) {
    return _.get(data, '$selected', false) == true;
}
exports.isRowSelected = isRowSelected;
//# sourceMappingURL=helpers.js.map